import { render, staticRenderFns } from "./CourseBook.vue?vue&type=template&id=697b0010&scoped=true&"
import script from "./CourseBook.vue?vue&type=script&lang=js&"
export * from "./CourseBook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "697b0010",
  null
  
)

export default component.exports